import { render, staticRenderFns } from "./ProductMainIframe.vue?vue&type=template&id=c188f9e6&"
import script from "./ProductMainIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductMainIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports